import css from './index.module.scss';
import { useState, useEffect } from 'react';
import { useLang } from '@/i18n';
import EfSpec from '@elem/ui/ef-spec';
import EfImg from '@elem/ui/ef-img';

interface ItemProps {
    title: string;
    desc: string[];
}
export default function G() {
    const { t } = useLang('delta_pro_ultra.launch.detail');
    const [enter, setEnter] = useState(false);
    const items: ItemProps[] = [
        {
            title: t('NEW1_item1_title'),
            desc: [t('NEW1_item1_text1'), t('NEW1_item1_text2')],
        },
        {
            title: t('NEW1_item2_title'),
            desc: [t('NEW1_item2_text1'), t('NEW1_item2_text2')],
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const scene = AniContainer.create({
                triggerElement: '.OASIS-B',

                offset: '100%',
                onEnter: () => setEnter(true),
            });
        }
    }, []);

    return (
        <section className={`dpu-new1 ${css['dpu-new1']}`}>
            <EfSpec />
            <h2 className="title">{t('NEW1_title')}</h2>
            <div className="scroll">
                <div className="video-box">
                    {enter && (
                        <EfImg
                            pc="https://websiteoss.ecoflow.com/upload/image/1742960077223/new1.jpg"
                            h5="https://websiteoss.ecoflow.com/upload/image/1742960077056/new1_M.jpg"
                        />
                    )}
                </div>
                <ul className="items">
                    {items?.map((item: ItemProps, k: number) => (
                        <li className="item" key={k}>
                            <p className="item-title">{item.title}</p>
                            <ul className="item-texts">
                                {item.desc?.map((text: string, m: number) => (
                                    <li className="item-text" key={k + '_' + m}>
                                        {text}
                                    </li>
                                ))}
                            </ul>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    );
}
